(function() {
	'use strict';

	angular
		.module('pwc.model')
		.service('WineGift', WineGift);

	WineGift.$inject = ['$window', 'BaseModel', 'Transaction'];

	function WineGift($window, BaseModel, Transaction) {

		// Entity Defaults
		var defaults = $window.stampit().state({
			"type": "gift",
			"date": new Date(),
			"notes": null,
			"to": null,
			"qty": 1
		});

		var WineGiftFactory = $window.stampit().enclose(function () {

			this.getSummary = function(){
				var summary = 'You gifted ' + this.qty + ' bottle' + (this.qty > 1 ? 's' : '');

				if (this.to){
					summary +=  ' to ' + this.to;
				}

				return summary + '.';
			};

			return $window.stampit.mixIn(this, BaseModel, Transaction);

		});

		return function(properties){
			return $window.stampit.compose(defaults, WineGiftFactory).create(properties);
		};

	}

})();
